import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="32" cy="32" r="17" fill="none" stroke="currentColor" strokeWidth="6" />
    <path d="M32 32h17" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
    <circle cx="32" cy="32" r="5" fill="#D96B43" />
  </svg>
);

export const Logo = ({ testId = "brand-logo" }) => (
  <Link to="/" data-testid={testId} className="flex items-center gap-2 text-[#F2EDE4]">
    <LogoMark />
    <span className="font-display text-xl font-bold tracking-tight">gobbloo</span>
  </Link>
);
